
import { webhook } from "@/api/webhook";
import { getField, updateField } from 'vuex-map-fields';


export const SET_WEBHOOK = "SET_WEBHOOK";
export const SET_LOADING = "SET_LOADING";
export const SET_COMPANY = "SET_COMPANY";
export const SET_ERRORS = "SET_ERRORS";

class Webhook {
    constructor({ id, url, hearders, company_id}) {
        this.id = id;
        this.url = url;
        this.companydb = company_id;
        this.headers = hearders;
        this.loading = false;
        this.errors = {
            url: [],
            headers: []
        };
    }
}

const models = {
    Webhook
};

const defaultData = new Webhook({id: undefined, url: undefined, hearders: undefined, company_id: undefined});

const state = () => ({
    webhook: defaultData,
});

const getData = ({ commit, dispatch, state, rootGetters, rootState }, { company_id }) => {
    return new Promise((resolve, reject) => {
        commit(SET_WEBHOOK, {companydb: company_id});
        commit(SET_LOADING, true);
        webhook.getData({companyId: company_id}).then(response => {
            if (response.data && response.data.count > 0) {
                commit(SET_WEBHOOK, response.data.results[0]);
            }
            commit(SET_LOADING, false);
            resolve();
        }).catch(error => {
            commit(SET_LOADING, false);
            reject();
        });
    });
};


const save = ({commit, dispatch, state, rootGetters, rootState}) => {
    let params = {
        url: state.webhook.url,
        headers: state.webhook.headers,
        companydb: state.webhook.companydb
    };
    commit(SET_LOADING, true);
    commit(SET_ERRORS, {url: [], headers: []});
    let callbackOK = function(response) {
        commit(SET_WEBHOOK, response.data);
        commit(SET_LOADING, false);
    }
    let callbackError = function(error) {
        commit(SET_ERRORS, error.response.data);
        commit(SET_LOADING, false);
    }
    let promise;
    if (state.webhook.id) {
        promise = webhook.update({webhookId: state.webhook.id, form:params});
    } else {
        promise = webhook.create({form:params})
    }
    promise.then(callbackOK, callbackError);
}

export const actions = {
    getData,
    save,
};

const mutations = {
    updateField,
    [SET_WEBHOOK](state, webhook) {
        state.webhook.id = webhook.id;
        state.webhook.url = webhook.url;
        state.webhook.companydb = webhook.companydb;
        state.webhook.headers = webhook.headers;
    },
    [SET_LOADING](state, loading) {
        state.webhook.loading = loading;
    },
    [SET_COMPANY](state, companyId) {
        state.webhook.company_id=companyId;
    },
    [SET_ERRORS](state, errors) {
        if (errors.url) {
            state.webhook.errors.url = errors.url;
        }
        if (errors.headers) {
            state.webhook.errors.headers = errors.headers;
        }
    }
}

const getters = {
    getField,
    webhook: state => state.webhook,
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
    models
}